// extracted by mini-css-extract-plugin
export default {"pageWrapper":"styles_pageWrapper__g171K","title":"styles_title__4QCEa"};